import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#5EAA22" stroke="#F7FCFF" d="M16.5-.5v13h-17v-13h17Z" />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 3v2h16V3H0ZM0 7v2h16V7H0Z"
        clipRule="evenodd"
      />
      <Path fill="#F50101" d="M0 0h8v7H0z" />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="m4.125 5.072-1.86 1.15.722-1.93L1.5 2.99h1.824l.801-1.925.611 1.925h1.802L5.273 4.29l.623 1.837-1.771-1.056Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
